import { render, staticRenderFns } from "./Proyectos.vue?vue&type=template&id=72be9394"
import script from "./Proyectos.vue?vue&type=script&lang=js"
export * from "./Proyectos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports